/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Brief_TitleInputs */

const en_mk_tb_brief_title = /** @type {(inputs: Mk_Tb_Brief_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with a brief`)
};

const id_mk_tb_brief_title = /** @type {(inputs: Mk_Tb_Brief_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari brief`)
};

/**
* | output |
* | --- |
* | "Start with a brief" |
*
* @param {Mk_Tb_Brief_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_brief_title = /** @type {((inputs?: Mk_Tb_Brief_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Brief_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_brief_title(inputs)
	return en_mk_tb_brief_title(inputs)
});